module.exports = __webpack_public_path__ + "img/elha-logo.c5a89845.svg";